/** @module Specification/CareAndComposition/CareCategoryRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale"
], function(declare, String, locale) {

	return declare(String, {
		/**
		 * Return localized name for enum
		 */
		formatValue: function(value, fmt) {
			return locale.getEnumName("CareSymbolType:" + value);
		}
	});
});
